import { render, staticRenderFns } from "./PlatformCopyright.vue?vue&type=template&id=00d1acc2"
import script from "./PlatformCopyright.vue?vue&type=script&lang=js"
export * from "./PlatformCopyright.vue?vue&type=script&lang=js"
import style0 from "./PlatformCopyright.vue?vue&type=style&index=0&id=00d1acc2&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports